export { default } from '@material-ui/core/TableCell';
